export const TRANSLATION_KEYS = {
    Heading: "ticketPage.deleteDialog.heading",
    SecondaryHeading: "ticketPage.deleteDialog.secondaryHeading",
    ConfirmText: "common.deleteText",
    DismissText: "common.dismissText"
};